import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import { createAdministered } from "../../actions/administered";
import { forceInputUppercase } from "../../utils/helper";


const $ = window.$;
class AddAdministered extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            administered: "",
            loading: false,
            inputNotValid: false
        };
    }
    handleChange = event => {
        forceInputUppercase(event);
        const value = event.target.value;
        this.setState({
            ...this.state,
            [event.target.name]: value
        });
    };
    submitAdministeredType(e) {
      e.preventDefault();
        this.setState({ loading: true });
        let data = {
            name: this.state.administered,
            type: this.props.type
        };
        let valid = this.state.administered.length > 0;

        if (valid) {
            this.props.createAdministered(data);
        } else {
            NotificationManager.warning("Administered data incomplete.");
            this.setState({ inputNotValid: true });
            this.setState({ loading: false });
        }
    }


    closeModal = () => {
        $("#add_administered_type").modal("hide");
        this.setState({
            administered: "",
            loading: false,
            inputNotValid: false
        });
    };

    componentWillReceiveProps = nextProps => {
        if (nextProps.administered && this.props.administered !== nextProps.administered) {
            this.setState({ administered: "", loading: false });        
            NotificationManager.success("Administered Type Added");
            $("#add_administered_type").modal("hide");
        }
        if (nextProps.administeredError && this.props.administeredError !== nextProps.administeredError) {
            this.setState({ administered: "", loading: false });
            const AdministeredTypeExists = "Administered type already exists";          
            if(nextProps.administeredError.message && nextProps.administeredError.message === AdministeredTypeExists){
              NotificationManager.error(nextProps.administeredError.message);
            }
            else{
              NotificationManager.error("Failed to add Administered Type");
            }                        
            $("#add_administered_type").modal("hide");
        }
    };

    // componentDidMount() {
    //   $('#add_administered_type').modal('show');
    //   document.body.style.overflow = 'hidden';
    // }
    
    // componentWillUnmount() {
    //     document.body.style.overflow = 'unset';
    // }

    render() {
        const type = this.props.type;
        return (
          <div
            className="modal fade show"
            id="add_administered_type"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <form className="m-form">
                  <div className="modal-header">
                    {type === "vaccine" ? (
                      <h5 className="modal-title" id="exampleModalLabel">
                        Create New Vaccination Type
                      </h5>
                    ) : type === "deworm" ? (
                      <h5 className="modal-title" id="exampleModalLabel">
                        Create New Treatment Type
                      </h5>
                    ) : null}
    
                    <button
                      type="button"
                      className="close"
                      onClick={this.closeModal}
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="m-form__section m-form__section--first">
                          {/* <div className="m-form__heading">
                                <h3 className="m-form__heading-title">User Details</h3>
                            </div> */}
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                              {type === "vaccine"
                                ? "Vaccination"
                                : type === "deworm"
                                ? "Treatment"
                                : null}{" "}
                              Type:
                            </label>
                            <div className="col-xl-9 col-lg-9">
                              <input
                                type="text"
                                name="administered"
                                onChange={e => this.handleChange(e)}
                                value={this.state.administered}
                                className="form-control m-input"
                                placeholder=""
                              />
                              <span
                                className={
                                  this.state.inputNotValid
                                    ? "m-form__help_danger"
                                    : "m-form__help"
                                }
                              >
                                Please enter{" "}
                                {type === "vaccine"
                                  ? "vaccination"
                                  : type === "deworm"
                                  ? "treatment"
                                  : null}{" "}
                                type
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    {this.state.loading == false ? (
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary m-btn--pill mx-2"
                          onClick={this.closeModal}
                        >
                          Close
                        </button>
                        <button
                          onClick={(e) => this.submitAdministeredType(e)}
                          type="submit"
                          className="btn btn-primary m-btn--pill"
                        >
                          Submit
                        </button>
                      </div>
                    ) : (
                      <div className="center-row">
                        <Loader size={50} />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        );
      }
    }
    
    const mapStateToProps = state => ({
      administered: state.administeredTypeReducer.setAdministered,
      administeredError: state.administeredTypeReducer.setAdministeredError
    });
    
    const mapDispatchToProps = dispatch => ({
      createAdministered: vaccine => {
        dispatch(createAdministered(vaccine));
      }
    });
    
    export default withRouter(
      connect(mapStateToProps, mapDispatchToProps)(AddAdministered)
    );
